/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Grid } from '@mui/material';
import SidebarNav from './sidebar-nav';
import Footer from '../footer';
import { Brand, Drawer, LargeAvatar, SmallAvatar } from './style/style';
//
const Sidebar = ({ items, showFooter = false, ...rest }) => (
  <Drawer variant="permanent" {...rest}>
    <Brand>
      <Grid
        item
        sx={{
          display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block' },
        }}
      >
        <LargeAvatar variant="square" src="/static/assets/logo-light.png" />
      </Grid>
      <Grid
        item
        sx={{
          display: { xs: 'block', sm: 'block', md: 'block', lg: 'block', xl: 'none' },
        }}
      >
        <SmallAvatar variant="square" src="/static/assets/logo-light.png" />
      </Grid>
    </Brand>

    <SidebarNav items={items} />
    {!!showFooter && <Footer />}
  </Drawer>
);
//
export default Sidebar;
